import { render, staticRenderFns } from "./OrderRecord.vue?vue&type=template&id=cf2e866c&scoped=true&"
import script from "./OrderRecord.vue?vue&type=script&lang=ts&"
export * from "./OrderRecord.vue?vue&type=script&lang=ts&"
import style0 from "./OrderRecord.vue?vue&type=style&index=0&id=cf2e866c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2e866c",
  null
  
)

export default component.exports